import React from 'react';
import {Field} from 'redux-form';
import FlatButton from 'material-ui/FlatButton';
import {LoomisColors} from '../../lib/LoomisColors';
import { required } from '../../lib/validators';
import MenuItem from 'material-ui/MenuItem';
import { Row, Col } from 'react-flexbox-grid';
import { SelectField, TextField } from 'redux-form-material-ui'
import translate from '../../lib/i18n/translate'
import logo from '../../img/loomis-logo.svg';

import './InviteUserForm.css'

export const Error = ({text, error}) => {
    if(error) {
        return (
            <div className="error">
                <div>{text}</div>
                <div>{error.message}</div>
            </div>
        )
    }
    return (<div/>);
};

const styles = {
    errorStyle: {
        color: LoomisColors.red,
    },
    underlineStyle: {
        borderColor: LoomisColors.darkerRed,
    },
    floatingLabelStyle: {
        color: LoomisColors.blueGrey,
        align: 'left',
        float: 'left'
    },
    floatingLabelFocusStyle: {
        color: LoomisColors.blueGrey,
    },
    textFieldStyle: {
        color: LoomisColors.white,
    },
};

const InviteUserForm = ({handleSubmit, strings}) => {
    const {Name, Language, NewPassword, ConfirmPassword, Submit, InviteHeader, InviteText} = strings;

    return (
        <div className="FormWrapper">
            <div className="UnAuthorizedHeader">
                <div className="container">
                    <Row>
                        <Col xs={12}>
                            <Row center="xs">
                                <Col xs={12} sm={6} md={4}>
                                    <img className="login-logo" src={logo} alt="Loomis"/>
                                    <div className="UnAuthorizedHeaderText">
                                        <h2>{InviteHeader}</h2>
                                        {InviteText}
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
            <div className="container">
                <Row>
                    <Col xs={12}>
                        <Row center="xs">
                            <Col xs={12} sm={6} md={4}>
                                <form className="InviteUser" onSubmit={handleSubmit}>
                                    <div>
                                        <Field
                                            name="displayName"
                                            component={TextField}
                                            hintText={Name}
                                            validate={[required]}
                                            floatingLabelText={Name}
                                            floatingLabelStyle={styles.floatingLabelStyle}
                                            errorStyle={styles.errorStyle}
                                            inputStyle={styles.textFieldStyle}/>
                                    </div>
                                    <div>
                                        <Field
                                            name="language"
                                            component={SelectField}
                                            hintText={Language}
                                            validate={[required]}
                                            floatingLabelText={Language}
                                            floatingLabelStyle={styles.floatingLabelStyle}
                                            errorStyle={styles.errorStyle}
                                            labelStyle={styles.textFieldStyle}>
                                            <MenuItem value="cz" primaryText="Čeština"/>
                                            <MenuItem value="dk" primaryText="Dansk"/>
                                            <MenuItem value="de" primaryText="Deutsch"/>
                                            <MenuItem value="nl" primaryText="Dutch"/>
                                            <MenuItem value="en" primaryText="English"/>
                                            <MenuItem value="es" primaryText="Español"/>
                                            <MenuItem value="fr" primaryText="Français"/>
                                            <MenuItem value="it" primaryText="Italiano"/>
                                            <MenuItem value="no" primaryText="Norsk"/>
                                            <MenuItem value="pt" primaryText="Português"/>
                                            <MenuItem value="sk" primaryText="Slovenčina"/>
                                            <MenuItem value="sv" primaryText="Svenska"/>
                                            <MenuItem value="fi" primaryText="Suomalainen"/>
                                            <MenuItem value="tr" primaryText="Türk"/>
                                        </Field>
                                    </div>
                                    <div>
                                        <Field
                                            name="password1"
                                            validate={[required]}
                                            component={TextField}
                                            type="password"
                                            hintText={NewPassword}
                                            floatingLabelText={NewPassword}
                                            floatingLabelStyle={styles.floatingLabelStyle}
                                            errorStyle={styles.errorStyle}
                                            underlineFocusStyle={styles.underlineStyle}
                                            floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                                            inputStyle={styles.textFieldStyle}
                                        />
                                    </div>
                                    <div>
                                        <Field
                                            name="password2"
                                            validate={[required]}
                                            component={TextField}
                                            type="password"
                                            hintText={ConfirmPassword}
                                            floatingLabelText={ConfirmPassword}
                                            floatingLabelStyle={styles.floatingLabelStyle}
                                            errorStyle={styles.errorStyle}
                                            underlineFocusStyle={styles.underlineStyle}
                                            floatingLabelFocusStyle={styles.floatingLabelFocusStyle}
                                            inputStyle={styles.textFieldStyle}
                                        />
                                    </div>
                                    <div className="ButtonWrapper">
                                        <FlatButton
                                            type="submit"
                                            backgroundColor="#fff"
                                            label={Submit}
                                            fullWidth={false}/>
                                    </div>
                                </form>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    )
};

export default translate('InviteUserForm')(InviteUserForm);





// WEBPACK FOOTER //
// ./src/components/invite/InviteUserForm.js